import { Component, Input } from '@angular/core';
import { CandidateAvailability, ShiftType } from '../../../../api';
import { BaseShifts } from '../../constants/base-shifts';

@Component({
  selector: 'base-candidate-shifts-availability',
  templateUrl: './base-candidate-shifts-availability.component.html',
})
export class BaseCandidateShiftsAvailabilityComponent {
  @Input() candidateAvailability: CandidateAvailability | undefined;

  shifts = BaseShifts;

  trackByShift(_: number, item: { icon: string; control: ShiftType }) {
    return item.control;
  }
}
